import { mergeAttributes, Node, ReactNodeViewRenderer } from '@tiptap/react';

import { SelectMediaNodeComponent, type SelectMediaNodeOptions } from '.';

export const SelectMediaNode = Node.create<SelectMediaNodeOptions>({
  name: 'select-media',
  group: 'block',
  draggable: true,
  selectable: true,
  atom: true,
  addOptions() {
    return {
      accept: 'image/*,video/*,audio/*',
      maxSize: 0,
      uploadFileFn: undefined,
      onFileUploaded: undefined,
      onFileUploadError: undefined,
      selectedCallbackFn: undefined,
    };
  },
  addAttributes() {
    return {
      maxSize: {
        default: this.options.maxSize,
      },
      accept: {
        default: this.options.accept,
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="select-media"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-type': 'select-media' }, HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(SelectMediaNodeComponent);
  },

  addCommands() {
    return {
      setSelectMediaNode:
        (options = {}) =>
        ({ commands, editor }) => {
          // Only allow insertion when editor is editable
          if (!editor.isEditable) {
            return false;
          }
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { selection } = editor.state;
        const { nodeAfter } = selection.$from;

        // Don't handle shortcut if editor is not editable
        if (!editor.isEditable) {
          return false;
        }

        if (nodeAfter && nodeAfter.type.name === 'select-media' && editor.isActive('select-media')) {
          const nodeEl = editor.view.nodeDOM(selection.$from.pos);
          if (nodeEl && nodeEl instanceof HTMLElement) {
            const firstChild = nodeEl.firstChild;
            if (firstChild && firstChild instanceof HTMLElement) {
              firstChild.click();
              return true;
            }
          }
        }
        return false;
      },
    };
  },
});
